module.exports = __webpack_public_path__ + "img/40e36e8.svg";